module.exports = __webpack_public_path__ + "img/3.febae342.jpeg";